export default __webpack_public_path__ + "static/media/report.67180f3e.svg";